import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatRadioModule,
  MatSelectModule, MatSliderModule, MatSlideToggleModule, MatExpansionModule, MatButtonModule, MatDialogModule,
  MatFormFieldModule, MatTooltipModule, MatCardModule, MatButtonToggleModule, MatDatepickerModule, MatDatepicker,
  MAT_DATE_LOCALE, MatTableModule, MatNativeDateModule, MatMenuModule, MatPaginatorModule, MatIconModule, MatSortModule,
  MatProgressSpinnerModule, MatProgressBarModule
} from '@angular/material';
export class MaterialModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonToggleModule,
    MatSortModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatIconModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonToggleModule,
    MatSortModule,
    MatButtonModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatIconModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MaterialModule_tsickle_Closure_declarations() {
/** @type {?} */
MaterialModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MaterialModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
